import { connect } from 'react-redux';
import Main from 'shared/layouts/Main';

const mapStateToProps = (state: any) => {
    return {
        minimizedBar: state.settings.minimizedBar
    };
}

export default connect(
    mapStateToProps
)(Main)